var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, styled } from 'styled-components';
import { getDynamicToken } from "../../utils/getDynamicToken";
import { pxToRem } from "../../utils";
export default styled.div.withConfig({
  displayName: "styled",
  componentId: "1_5_0__sc-5k6o75-0"
})(["", "{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var $marginBottom = _ref2.$marginBottom,
    $marginLeft = _ref2.$marginLeft,
    $marginRight = _ref2.$marginRight,
    $marginTop = _ref2.$marginTop,
    theme = _ref2.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border: ", " solid\n        ", ";\n      border-radius: ", ";\n      margin: ", "\n        ", "\n        ", "\n        ", ";\n      padding: calc(\n        ", " - ", "\n      );\n\n      @media (min-width: ", ") {\n        padding: calc(\n          ", " - ", "\n        );\n      }\n\n      &:focus {\n        outline: ", "rem solid transparent;\n        outline-offset: ", "rem;\n      }\n\n      & > *:last-child {\n        margin-bottom: 0;\n      }\n    "])), theme.vars.errorsummary_color_background, theme.vars.errorsummary_border_width, theme.vars.color_border_critical, theme.vars.errorsummary_border_radius, getDynamicToken(theme.vars, "spacing_".concat($marginTop)), getDynamicToken(theme.vars, "spacing_".concat($marginRight)), getDynamicToken(theme.vars, "spacing_".concat($marginBottom)), getDynamicToken(theme.vars, "spacing_".concat($marginLeft)), theme.vars.spacing_03, theme.vars.errorsummary_border_width, theme.breakpoint_md, theme.vars.spacing_05, theme.vars.errorsummary_border_width, pxToRem(2), pxToRem(2));
});
export var StyledErrorSummaryTextIconContainer = styled.div.withConfig({
  displayName: "styled__StyledErrorSummaryTextIconContainer",
  componentId: "1_5_0__sc-5k6o75-1"
})(["", "{display:flex;align-items:flex-start;@media (max-width:", "){display:block;}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.cssPrefix;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint_md;
});
export var StyledErrorSummaryIconContainer = styled.div.withConfig({
  displayName: "styled__StyledErrorSummaryIconContainer",
  componentId: "1_5_0__sc-5k6o75-2"
})(["", "{display:flex;@media (max-width:", "){margin-bottom:", ";}}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.cssPrefix;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoint_md;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.vars.spacing_04;
});
export var StyledErrorSummaryTextContainer = styled.div.withConfig({
  displayName: "styled__StyledErrorSummaryTextContainer",
  componentId: "1_5_0__sc-5k6o75-3"
})(["", "{", "}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.cssPrefix;
}, function (_ref9) {
  var theme = _ref9.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-left: ", ";\n\n      @media (max-width: ", ") {\n        margin-left: 0;\n      }\n    "])), theme.vars.spacing_04, theme.breakpoint_md);
});
export var StyledErrorSummaryChildrenContainer = styled.ul.withConfig({
  displayName: "styled__StyledErrorSummaryChildrenContainer",
  componentId: "1_5_0__sc-5k6o75-4"
})(["", "{", "}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.cssPrefix;
}, function (_ref11) {
  var theme = _ref11.theme;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-left: ", "rem;\n      margin-top: ", ";\n      padding-left: 0;\n\n      @media (max-width: ", ") {\n        margin-left: 0;\n        padding-left: 0;\n      }\n    "])), pxToRem(44), theme.vars.spacing_05, theme.breakpoint_md);
});